import React, { useState } from 'react';

import MainHeader from '../../ui-components/MainHeader';
import TopHeaderUi from '../../ui-components/TopHeaderUi';

import TaskView from './TaskView';
import ProjectView from './ProjectView';
import CreateModal from './ProjectCreateModal';
import TaskDetails from './TaskDetails';
import ProjectList from './ProjectList';
import CreateDesign from './CreateDesign';
const TaskWrapper = () => {
	const [activeTab, setActiveTab] = useState('Task List');
	const uiTabs = [
		'Task List',
		'Project Details',
		'Create Modal',
		'Project View',
		'Project List',
		'Create Design'
	];
	const renderComponents = () => {
		switch (activeTab) {
			case 'Task List':
				return <TaskView />;

			case 'Create Modal':
				return <CreateModal />;
			case 'Project Details':
				return <TaskDetails />;
			case 'Project View':
				return <ProjectView />;
			case 'Project List':
				return <ProjectList />;
			case 'Create Design':
				return <CreateDesign />;
		}
	};
	return (
		<div className="content">
			<MainHeader />
			<div className="wraper container-fluid dashboard-container bg-gray">
				<TopHeaderUi activeTab={activeTab} setActiveTab={setActiveTab} tabs={uiTabs} />
				{renderComponents()}
			</div>
		</div>
	);
};

export default TaskWrapper;
